import classNames from 'classnames';
import React, { FC, memo, useCallback } from 'react';
import { Box } from 'entities/Box';
import { RentOptionDocument } from 'entities/RentOption';
import { useGetBoxesSuggestionQuery } from 'features/SizeCodeCollapse/api/getBoxesSuggestion';
import { UserAccountType } from 'entities/User';
import { ModernBoxCard } from './ModernBoxCard';
import { WarehouseForBooking } from 'entities/Warehouse';

interface ModernBoxesContainerProps {
  sizeCodeId: string;
  selectedBoxId: string | undefined;
  rentDiscounts: RentOptionDocument[];
  generalDiscounts: RentOptionDocument[];
  onSelectBox: (box: Box) => void;
  onBookBox: (box: Box) => void;
  accountType?: Nullable<UserAccountType>;
  warehouseInfo?: Nullable<WarehouseForBooking>;
}

export const ModernBoxesContainer: FC<ModernBoxesContainerProps> = memo((props) => {
  const { sizeCodeId, selectedBoxId, rentDiscounts, generalDiscounts, onSelectBox, onBookBox, accountType, warehouseInfo } = props;
  const { data } = useGetBoxesSuggestionQuery(sizeCodeId, { skip: !sizeCodeId });

  const selectBox = useCallback(
    (box: Box): void => {
      onSelectBox(box);
    },
    [onSelectBox],
  );

  const bookBox = useCallback(
    (box: Box): void => {
      onBookBox(box);
    },
    [onBookBox],
  );

  const hasRentDiscounts = rentDiscounts.length > 0;
  const hasGeneralDiscounts = generalDiscounts.filter(({ showAsPromotion }) => showAsPromotion).length > 0;

  return (
    <div className={classNames('relative', { 'min-h-[307px]': !data?.content.length })}>
      <div className={classNames('space-y-3', { 'blur-[3px] pointer-events-none': data?.noAvailableBoxes })}>
        {Boolean(data?.content.length) &&
          data?.content.map((box) => (
            <ModernBoxCard
              key={box.boxId}
              box={box}
              selectedBoxId={selectedBoxId}
              hasRentDiscounts={hasRentDiscounts}
              hasGeneralDiscounts={hasGeneralDiscounts}
              onSelectBox={selectBox}
              onBookBox={bookBox}
              accountType={accountType}
              warehouseInfo={warehouseInfo}
            />
          ))}
      </div>
    </div>
  );
});
